import { useState, useRef, useEffect } from "react";
import SearchPanel from "./SearchPanel";
import { groups } from "./groups";
import Fuse from "fuse.js";
import "./ResearchGroupSearchResults.css";
import { Link, useLocation } from "react-router-dom";
import { ProgressPanel } from "./ProgressPanel";

export default function ResearchGroupSearchResult(props) {

    const [fetching, setFetching] = useState();
    const [lgroups, setLGroups] = useState([]);
    const oldSearch = useRef("");
    const location = useLocation();
    const param = new URLSearchParams(location.search);
    
    param.delete("search");
    
    const infoFileCount = groups.reduce((infoFileCount, gr) => infoFileCount + Object.values(gr.file).length, 0);

    useEffect(()=> {

        if (props.search && props.search !== oldSearch.current) {
            setFetching(infoFileCount);
            groups.map((gr, gix) => 
                Object.values(gr.file).map(fl =>
                    fetch(`./data/${fl}`)
                        .then(res => res.json())
                        .then(dta => {
                            dta["id"] = gr.id;
                            const promises = [];
                            if (dta.description.slice(0, 5) === "file:")
                                promises.push(fetch(`./data/${dta.description.slice(5)}`)
                                    .then((res) => res.text())
                                    .then((md) => dta.description = md));
                            if (dta.results.slice(0, 5) === "file:")
                                promises.push(fetch(`./data/${dta.results.slice(5)}`)
                                    .then((res) => res.text())
                                    .then((md) => dta.results = md));
                            Promise.all(promises).then(() => {
                                setLGroups(g => {
                                    const items = [ ...g];                                
                                    items[gix] = dta;
                                    return items;
                                });
                                setFetching(s => s-1);
                            });
                        })
                )
            );
            oldSearch.current = props.search;
        }
    }, [props, infoFileCount]);

    if (fetching)
        return <ProgressPanel id="research-group-search-result" lang={props.lang} progress={Math.floor(100 * (infoFileCount-fetching) / infoFileCount)}/>;

    const fuse = new Fuse(lgroups, {keys: ["name.hu", "name.en", "keywords", "staff.name", "description", "results", "infrastructure", "international", "projects", "partners"], ignoreLocation: true, includeScore: true, ignoreFieldNorm: true});
    let hits = [];
    if (props.search)
        hits = fuse.search(props.search);

    return (
        <div id="research-group-search-result">
            <div className="upper">
                <SearchPanel lang={props.lang}/>
            </div>
            {props.search && <h1>{props.lang==="hu" ? "Találatok:" : "Search results:"}</h1>}
            <div className="search-result-container">
                {hits.map((hit, hix) => <Link to={`/groups/${hit.item.id}?${param.toString()}`} key={hix} className="search-result">
                        <div>{hit.item.name[props.lang]}</div>
                        <div>{props.lang==="hu"? "Pont:" : "Score:"}{(100*(1.0-hit.score)).toFixed(4)}</div>
                    </Link>)}
            </div>
        </div>        
    );
}